import React from 'react';

const InpaintSvg = ({
  color = '#ffffff',
  size = 24,
  //   variant = 'stroke', // "stroke" | "fill"
  //   strokeWidth = 2,
  //   title,
  //   className = '',
  //   ...props
}) => {
  color = color === '#fff' || color === '#ffffff' ? '#eeeeee' : color;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M21.1099 14.2429V23.1714H2.91602L2.91602 14.2429L21.1099 14.2429Z" />
      <path d="M21.1099 14.2429V23.1714H2.91602L2.91602 14.2429L21.1099 14.2429Z" />
      <path d="M9.21603 8.56655L9.21603 3.97228C9.23403 3.18708 9.49683 2.53553 10.0032 2.01882C10.5096 1.50212 11.148 1.24316 11.916 1.24316C12.684 1.24316 13.3224 1.50212 13.8288 2.01882C14.3352 2.53553 14.5968 3.18708 14.616 3.97228V8.56655H17.316C18.3288 8.58565 19.1772 8.94483 19.8612 9.64412C20.5452 10.3434 20.8968 11.2098 20.916 12.2432L2.91603 12.2432C2.93403 11.2086 3.28683 10.3422 3.97083 9.64412C4.65483 8.94603 5.50443 8.58684 6.51603 8.56655L9.21603 8.56655Z" />
      <path d="M9.21603 8.56655L9.21603 3.97228C9.23403 3.18708 9.49683 2.53553 10.0032 2.01882C10.5096 1.50212 11.148 1.24316 11.916 1.24316C12.684 1.24316 13.3224 1.50212 13.8288 2.01882C14.3352 2.53553 14.5968 3.18708 14.616 3.97228V8.56655H17.316C18.3288 8.58565 19.1772 8.94483 19.8612 9.64412C20.5452 10.3434 20.8968 11.2098 20.916 12.2432L2.91603 12.2432C2.93403 11.2086 3.28683 10.3422 3.97083 9.64412C4.65483 8.94603 5.50443 8.58684 6.51603 8.56655L9.21603 8.56655Z" />
    </svg>

    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width={size}
    //   height={size}
    //   fill={variant === 'fill' ? color : 'none'}
    //   stroke={variant === 'stroke' ? color : 'none'}
    //   strokeWidth={strokeWidth}
    //   viewBox="0 0 24 24"
    //   className={className}
    //   aria-hidden={!title}
    //   role={title ? 'img' : 'presentation'}
    //   {...props}>
    //   {title ? <title>{title}</title> : null}
    //   <path
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //     d="M12 21s-6.716-4.485-9.374-8.136C.49 9.586 2.015 5 6.064 5c2.153 0 3.547 1.528 3.936 2.057.39-.53 1.783-2.057 3.936-2.057 4.049 0 5.574 4.586 3.438 7.864C18.716 16.515 12 21 12 21z"
    //   />
    // </svg>
  );
};

export default InpaintSvg;
